import { useState } from "preact/hooks";

interface ResetPasswordRequestFormProps {
  showSignInForm: () => void;
  initialEmail?: string;
  onSubmit: (email: string) => Promise<void>; // New prop for handling submission
  isSubmitting: boolean; // New prop to indicate submission state
  submitError?: string | null; // Optional: to display errors directly in the form
  submitSuccess?: string | null; // Optional: to display success messages
}

export function ResetPasswordRequestForm(
  { showSignInForm, initialEmail, onSubmit, isSubmitting, submitError, submitSuccess }: ResetPasswordRequestFormProps,
) {
  const [email, setEmail] = useState(initialEmail || "");

  const handleSubmit = (e: Event) => {
    e.preventDefault();
    onSubmit(email);
  };

  return (
    <>
      <h2 class="h1 mb-6">Reset Password</h2>
      {/* Display success message */}
      {submitSuccess && (
        <div class="text-center text-green-500 p-2 my-2 border border-green-500 rounded">
          {submitSuccess}
        </div>
      )}
      {/* Display error message */}
      {submitError && (
        <div class="text-center text-red-500 p-2 my-2 border border-red-500 rounded">
          {submitError}
        </div>
      )}
      {!submitSuccess && ( // Hide form on success
        <form onSubmit={handleSubmit} class="space-y-4">
          {/* Removed hidden formType input, it will be handled by the island */}
          <div>
            <label class="block text-sm font-medium p">
              Email
              <input
                // type="email" // Changed from text to email for better validation
                name="email"
                required
                autoFocus
                value={email}
                onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
                class="mt-1 block w-full px-3 py-2 b30 border border30 rounded-md p"
                placeholder="Enter your email"
                disabled={isSubmitting}
              />
            </label>
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            class="w-full bg-accent text-color10 py-2 px-4 rounded-md font-bold hover:opacity-90 disabled:opacity-50"
          >
            {isSubmitting ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      )}
      <div class="mt-4 text-center">
        <button
          type="button"
          onClick={showSignInForm}
          disabled={isSubmitting} // Disable if submitting, though less critical here
          class="text-color10 small hover:underline bg-slate-500 py-2 px-4 rounded-md disabled:opacity-70"
        >
          Back to Sign In
        </button>
      </div>
    </>
  );
}
